module.exports = __webpack_public_path__ + "img/image_1.cb15998f.jpg";